import { FC } from "react";
import BookingSummary from "../components/BookingSummary";
import HotelDetailsCard from "../components/HotelDetailsCard";
import HotelPoliciesCard from "../components/HotelPoliciesCard";
import HotelPaymentCard from "../components/HotelPaymentCard";
import { getHotelBookingSummaryCardData, hotelOrderDataMap } from "../constants";
import { HotelTransactionDetailsLayoutProps } from "./types";

const HotelTransactionDetailsWeb: FC<HotelTransactionDetailsLayoutProps> = ({ data, hotelDetails, payment, rateConditions }) => {
  return (
    <div className="flex w-full gap-2 md:gap-10">
      <div className="flex min-w-0 flex-3 flex-col gap-4">
        <BookingSummary cardData={getHotelBookingSummaryCardData(data)} dataMap={hotelOrderDataMap} />
        {hotelDetails && <HotelDetailsCard data={hotelDetails} />}
        <HotelPoliciesCard rateConditions={rateConditions} />
      </div>
      <div className="flex-1">
        <HotelPaymentCard payment={payment} />
      </div>
    </div>
  );
};

export default HotelTransactionDetailsWeb;
